import { useRef } from 'react';
import TickGreen from '../../../../Assets/Modals/TickGreen.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, setChangeType, setPagetype, setPageTypeDropdownOpen, setSectionFormType } from '../../../../Features/storefrontSlice';

function SwitchPageConfirmation() {
    const dispatch = useDispatch();

    const changeType = useSelector((state) => state.storefront.changeType);

    const wrapperRef = useRef(null);

    const handleCancelClick = () => {
        dispatch(setChangeType(null));
        dispatch(setPageTypeDropdownOpen(false));
        dispatch(closeModal());
    }

    const handleSwitchClick = async () => {
        dispatch(setPagetype(changeType));
        dispatch(setPageTypeDropdownOpen(false));
        dispatch(setSectionFormType(null));
        dispatch(closeModal());
    };

    return (
        <div ref={wrapperRef} className="w-[38%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex gap-3">
                <div className="size-12 flex items-center justify-center bg-[#D1FAE5] rounded-full">
                    <div className="size-6 flex items-center justify-center">
                        <img src={TickGreen} alt="" />
                    </div>
                </div>

                <div className="flex flex-col gap-4 w-[calc(100%-48px)]">
                    <div className="flex flex-col gap-2">
                        <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Switch Page?</h1>

                        <p className='font-normal text-[14px] leading-5 text-[#666666]'>Changes will be lost if you switch pages. Save them before you switch.</p>
                    </div>

                    <div className="flex justify-end gap-3 font-medium font-inter">
                        <button onClick={handleCancelClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                        <button onClick={handleSwitchClick} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-primaryColor shadow-[0px_1px_2px_0px_#0000000D]'>Switch</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SwitchPageConfirmation;
